import Icon from '../Icon';
import { IconSpecificProps } from '../Icon.types';

const IconLegalCheck = ({ className, titleAccess }: IconSpecificProps) => (
  <Icon className={className} titleAccess={titleAccess} viewBox="0 0 55 27" fill="none">
    <rect x="1" y="1" width="53" height="25" rx="12.5" stroke="white" strokeWidth="2" />
    <path
      d="M34.5 2H41.5C47.8513 2 53 7.14873 53 13.5C53 19.8513 47.8513 25 41.5 25H27L34.5 2Z"
      fill="#E5E7EB"
    />
    <path
      d="M46.6667 9.36838L37.3334 18.7017M37.3334 9.36838L46.6667 18.7017"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.1499 9.54504L14.8999 17.795L11.1499 14.045"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default IconLegalCheck;
